import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "content"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "content-box" }, [
  /*#__PURE__*/_createElementVNode("p", null, "It looks like you have cookies disabled. You'll need to enable those for this game to function. Rest assured, unlike those Big Tech™ companies, we don't really care what you do in your free time*, and the one cookie we place for the purposes of this game is only used for said purpose."),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("small", null, "* I mean, I guess we do care in that friendly way, but you probably know what I mean.")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const cookiesEnabled = navigator.cookieEnabled;

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_unref(cookiesEnabled))
    ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})